module.exports = __webpack_public_path__ + "img/school4.18275b89.jpg";